module.exports = __webpack_public_path__ + "static/media/patch-default.799f2818.webp";